<template>
  <v-dialog :value="value" :max-width="maxWidth" :fullscreen="mobile" :retain-focus="dialogOnTop" scrollable dark
    content-class="customer-hub-sheet" :transition="mobile ? 'dialog-bottom-transition' : 'dialog-transition'" @input="$emit('input', $event)">
    <v-card class="hub-sheet">
      <header class="hub-sheet__header"><v-btn icon :aria-label="title + ' schliessen'" @click="$emit('input', false)"><v-icon>{{ mobile ? 'mdi-arrow-left' : 'mdi-close' }}</v-icon></v-btn><h2>{{ title }}</h2><slot name="actions" /></header>
      <v-card-text class="hub-sheet__body"><slot /></v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { openHubDialog } from "@/services/customerHubDialogHistory"
export default {
  props: { value: Boolean, title: { type: String, default: "Details" }, maxWidth: { type: [String, Number], default: 720 } },
  data: () => ({ dialogOnTop: true }),
  computed: { mobile() { return this.$vuetify.breakpoint.xsOnly } },
  watch: { value: { immediate: true, handler(value) {
    if (value && !this.dialogHistory) this.dialogHistory = openHubDialog(this.$router, () => { this.dialogHistory = null; this.$emit("input", false) }, onTop => { this.dialogOnTop = onTop })
    else if (!value && this.dialogHistory) { const history = this.dialogHistory; this.dialogHistory = null; history.close() }
  } } },
  beforeDestroy() { this.dialogHistory?.close(); this.dialogHistory = null },
}
</script>
<style>
.customer-hub-sheet { border-radius: 22px; }
.customer-hub-sheet > .hub-sheet { background: #1f1f1f !important; color: #f5f5f5; }
.hub-sheet__header { display: flex; flex: 0 0 auto; align-items: center; gap: 10px; min-height: 68px; padding: 10px 16px; border-bottom: 1px solid #ffffff0d; }
.hub-sheet__header h2 { flex: 1; min-width: 0; font-size: 18px; line-height: 1.3; letter-spacing: -.3px; margin: 0; overflow-wrap: break-word; word-break: normal; }
.hub-sheet__header .v-btn { flex: 0 0 44px; width: 44px; height: 44px; }
.customer-hub-sheet .hub-sheet__body { padding: 24px !important; color: #b8b8b8; overscroll-behavior-y: contain; }
@media (max-width: 599px) {
  .customer-hub-sheet { border-radius: 0 !important; max-height: 100%; }
  .customer-hub-sheet > .hub-sheet { min-height: 100%; }
  .hub-sheet__header { padding: calc(8px + env(safe-area-inset-top, 0px)) 12px 8px; }
  .customer-hub-sheet .hub-sheet__body { padding: 20px 16px calc(28px + env(safe-area-inset-bottom, 0px)) !important; }
}
@media (prefers-reduced-motion: reduce) { .customer-hub-sheet { transition: none !important; animation: none !important; } }
</style>
